import { useState, useEffect } from "react";
import { InformationDetailModel } from "../../models/information.model";
import { getAllCollectedInformation } from "../../services/collectedinformation.service";

interface UseCollectedInformationResult {
  data: InformationDetailModel[] | null;
  isLoading: boolean;
  isEmpty: boolean;
  error: string | null;
}

export function useCollectedInformation(): UseCollectedInformationResult {
  const [data, setData] = useState<InformationDetailModel[] | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    async function fetchData() {
      setIsLoading(true);
      try {
        const result = await getAllCollectedInformation();
        if (isMounted) {
          setData(result);
        }
      } catch (err: any) {
        if (isMounted) {
          setError(err.message || "Something went wrong");
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    data,
    isLoading,
    isEmpty: data !== null && data.length === 0,
    error,
  };
}
